import * as types from 'actions/constants/ActionTypes';
import { _WebApi, WebApi } from 'actions/index.jsx';
import { continueRequests } from "../../api";
import { userDetailChange, userDetailRequest } from 'actions/user/userDetail.jsx';
import { routerNavigate } from 'actions/router.jsx';

/**
 * Checks if user is logged on server by requesting userDetail.
 * If yes, saves the returned detail to store.
 * If not, resets store to default.
 */
/**
 * @param {(logged: boolean) => void} callback dostane true, když je uživatel přihlášený
 */
export function checkUserLogged(callback = () => { }) {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(userDetailRequest());
        // calls original _getUserDetail method, which is not postponed until login
        _WebApi.getUserDetail().then(
            userDetail => {
                if (userDetail && !state.login.logged) {
                    // fake local login if user is logged on server
                    dispatch(loginSuccess(userDetail));
                }
                // we are logged -> continue with callback
                callback(true);
            },
            error => {
                dispatch(userDetailChange(null));
                dispatch(loginFail());
                callback(false);
            },
        );
    };
}

/**
 * Changes the state to logged-in and connects the websockets.
 */
function loginSuccess(forcedUserDetail) {
    return (dispatch, getState) => {
        const state = getState();

        window.ws.connect();

        let action = {
            type: types.LOGIN_SUCCESS,
        };

        if (forcedUserDetail) {
            dispatch(saveLoggedUser(forcedUserDetail));
            action.reset = state.userDetail.id !== forcedUserDetail.id;
            dispatch(action);
        } else {
            dispatch(userDetailRequest());
            WebApi.getUserDetail().then(userDetail => {
                dispatch(saveLoggedUser(userDetail));
                action.reset = state.userDetail.id !== userDetail.id;
                dispatch(action);
            });
        }

        continueRequests();
        WebApi.onLogin();
    };
}

function loginFail() {
    return {
        type: types.LOGIN_FAIL,
    };
}

/**
 * Saves the given userDetail as currently logged-in user's detail
 */
function saveLoggedUser(userDetail, reset) {
    return (dispatch, getState) => {
        if (reset) {
            dispatch(routerNavigate('/'));
        }
        dispatch(userDetailChange(userDetail));
    };
}

export function login(username, password) {
    return (dispatch, getState) => {
        return _WebApi.login(username, password).then(data => {
            dispatch(loginSuccess());
        });
    };
}

/**
 * Disconnects websockets and changes the state to logged-out, without calling the server.
 *
 * Used when the server has already refused the request as unauthorized. There is no session
 * left to end, and a logout call would destroy the one that SSO is establishing at that moment.
 */
export function clearSession() {
    return dispatch => {
        window.ws.disconnect(undefined, true);
        dispatch({
            type: types.LOGOUT,
            reset: true,
        });
    };
}

/**
 * Disconnects websockets, logs out the user and changes the state to logged-out.
 */
export function logout(redirect = false) {
    return dispatch => {
        dispatch(clearSession());
        if (redirect) {
            dispatch(routerNavigate('/'));
        }

        return WebApi.logout();
    };
}
